import React from 'react';
import { TableData, Button } from '@bambuser-ui';
import { TableRow } from '@material-ui/core/index.js';
import UserInfo from './UserInfo.jsx';

const TableRowUser = ({ user, disabled, onClick, attribute, buttonIcon }) => {
  return (
    <TableRow style={styles.tableRow}>
      <TableData style={styles.tableData}>
        <UserInfo user={user} attribute={attribute} />
        <Button
          size="smallSquare"
          disabled={disabled}
          icon={buttonIcon}
          onClick={() => onClick(user)}
          style={styles.crossButton}
        />
      </TableData>
    </TableRow>
  );
};

const styles = {
  tableRow: {
    backgroundColor: '#fff',
  },
  tableData: {
    alignItems: 'center',
    display: 'flex',
    fontWeight: 500,
    justifyContent: 'space-between',
    marginBottom: 18,
  },
  crossButton: {
    border: 'transparent',
    backgroundColor: 'transparent',
  },
};

export default TableRowUser;
